
















import { defineComponent, reactive } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import SearchInput from '@/components/organisms/special-offer-receipts/SearchInput.vue'
import SpecialOfferReceiptsTable from '@/components/organisms/special-offer-receipts/SpecialOfferReceiptsTable.vue'
import useVuex from '@/utils/useVuex'
import { SpecialOfferReceiptState, UserState } from '@/types/store'
import { GetSpecialOfferReceiptQuery } from '@/types/special-offer'

export default defineComponent({
  name: 'AdminSpecialOfferReceipt',
  components: {
    Layout,
    SearchInput,
    SpecialOfferReceiptsTable,
  },
  setup(props, context) {
    const target = 'admin'
    const store = context.root.$store
    const specialOfferId =
      typeof context.root.$route.query.id === 'string'
        ? parseInt(context.root.$route.query.id)
        : undefined
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      specialOfferReceipts: useVuex<
        SpecialOfferReceiptState['specialOfferReceipts']
      >(
        context,
        () => store.getters['specialOfferReceipt/specialOfferReceipts'],
      ),
      total: useVuex<SpecialOfferReceiptState['total']>(
        context,
        () => store.getters['specialOfferReceipt/total'],
      ),
      isSpecialOfferReceiptLoading: useVuex<
        SpecialOfferReceiptState['isSpecialOfferReceiptLoading']
      >(
        context,
        () => store.getters['specialOfferReceipt/isSpecialOfferReceiptLoading'],
      ),
    })

    const search = ({
      status,
      ...query
    }: GetSpecialOfferReceiptQuery & { status?: string | null }) => {
      store.dispatch('specialOfferReceipt/getSpecialOfferReceipts', {
        query: {
          ...query,
          dummy: '',
        },
        target: status === null ? target : status,
      })
    }

    return { state, specialOfferId, search, target }
  },
})
